import { HelpLink } from "../shell"
import { DialogHeader } from "./DialogHeader"

interface Props {
    link: HelpLink
    close: (result?: any) => void
}

export function HelpDialog({ link, close }: Props) {

    return <>

        <DialogHeader help={false}>
            {link.title}
        </DialogHeader>

        <div className="modal-body">

            <iframe width="560" height="415" src={`https://www.youtube.com/embed/${link.link}`} frameBorder="0"
                allowFullScreen={false} />

        </div>

        <div className="modal-footer">

            <a className="btn btn-info" target="_blank" href={`https://www.youtube.com/watch?v=${link.link}`}>Open in new tab</a>

            <button className="btn btn-primary" type="button" onClick={close}>Close</button>

        </div>

    </>

}
